export const GRUPOSAESA_LOGO = `${process.env.REACT_APP_ASSETS_URL}/images/grupo-saesa-logo-blanco.svg`;
export { default as LOGIN_LOGO } from './login-logo.svg';
export { default as USER_LOGO } from './user-logo.svg';
export { default as ERROR } from './error.svg';
export { default as MODAL_GUARDAR_ICONO } from './modal-guardar-icono.svg';
export { default as MODAL_ADVERTENCIA_ICONO } from './modal-advertencia-icono.svg';
export { default as RESET_ICONO } from './reset.svg';
export { default as EXPORT_ICONO } from './export.svg';
export { default as EXPORT_ICONO_DISABLED } from './export-disabled.svg';
export { default as ICONO_ERRROR } from './icono-error.svg';
export { default as USER_ICONO } from './user-icono.svg';
export { default as DOWNLOAD_ICONO } from './export.svg';
export { default as LOADING_ICONO } from './reset.svg';
export { default as INFO_ICONO } from './infoIcon.svg';
export { default as PDF_MINI_ICON } from './pdfMiniIcon.svg';
export { default as EXCEL_MINI_ICON } from './excelMiniIcon.svg';
export { default as DOCUMENT_UPLOAD } from './document-upload.svg';
export { default as CANCEL_ICON } from './cancelIcon.svg';
export { default as ERROR_ICON_GREY } from './error-grey.svg';
export { default as ERROR_CONEXION_GREY } from './error-conexion.svg';
export { default as EXPORT_AZUL } from './export-azul.svg';
export { default as TRASH_AZUL } from './trash-azul.svg';
export { default as EDIT_AZUL } from './edit-azul.svg';
export { default as TRASH_BLANCO } from './trash-blanco.svg';
export { default as TICK_CIRCLE_BLANCO } from './tick-circle-blanco.svg';
export { default as DOCUMENT_UPLOAD_BLANCO } from './document-upload-blanco.svg';
export { default as CIRCULO_ERROR } from './circulo-error.png';
export { default as TRIANGULO_ALERTA } from './triangulo-alerta.png';
export { default as EMPTY_TARIFAS_FONDO } from './empty-tarifas-fondo.svg';
export { default as EMPTY_TARIFAS_SPARKLES } from './empty-tarifas-sparkles.svg';
export { default as EMPTY_TARIFAS_ILUSTRACION } from './empty-tarifas-ilustracion.svg';
export { default as EMPTY_TARIFAS_ADD } from './empty-tarifas-add.svg';
